// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
const routerActions = require('client-v2/common/state/router/actions')
// ShareModal container imports
const shareModalActions = require('../actions')
const shareModalSelectors = require('../selectors')

function mapStateToProps(state) {
  if (!shareModalSelectors.isFriendsVisible(state)) {
    return { isVisible: false }
  }
  return {
    isVisible: true,
    friendsCount: shareModalSelectors.friendsCount(state),
    friendsSearch: shareModalSelectors.friendsSearch(state),
    friendsState: shareModalSelectors.friendsState(state),
    isSocialAuthCardVisible: shareModalSelectors.isSocialAuthCardVisible(state),
    searchText: shareModalSelectors.searchText(state),
    submitState: shareModalSelectors.submitState(state),
    user: state.user
  }
}

const mapDispatchToProps = {
  onFriendClick: shareModalActions.toggleFriend,
  onFriendsSearch: shareModalActions.setSearchText,
  onFriendsShare: shareModalActions.shareWithFriends,
  onNavigate: routerActions.navigate
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      require('./share-friends-dumb')
    )
  )
)
